import React, {Component, Fragment} from 'react';
import Select from 'react-select';

class LanguageForm extends Component {

	languageChangeHandler = (language) => {
		const {availableLanguages, changeLanguage} = this.props;
		const nextLanguage = availableLanguages.find(lang => lang.id === language.value);
		changeLanguage(nextLanguage);
		this.updateLocation(nextLanguage);
	};

	updateLocation = (nextLanguage) => {
		const {history, location, availableLanguages, defaultLanguage} = this.props;
		const pathArray = location.pathname.split('/');
		const isMainPage = location.pathname === '/';
		if (availableLanguages.findIndex(lang => lang.code === pathArray[1]) > -1) {
			if (nextLanguage.id === defaultLanguage.id) {
				history.push(location.pathname.substring(3));
			} else {
				history.push('/' + nextLanguage.code + location.pathname.substring(3));
			}
		} else {
			if (nextLanguage.id === defaultLanguage.id) {
				history.push(location.pathname);
			} else {
				history.push('/' + nextLanguage.code + (isMainPage ? '' : location.pathname));
			}
		}
	};

	flagRenderer = (value) => {
		const label = value.label.split('_');
		let country = label.length > 1 ? label[1].toLowerCase() : label[0].toLowerCase();
		let language = country.toLowerCase() === 'ba' ? 'bih' : label[0];

		return (
			<Fragment>
				<i className={`flag-icon flag-icon-${country.replace('us','gb')}`}/>
				<span className="language-select__text">{language}</span>
			</Fragment>
		);
	};

	render() {
		const {availableLanguages, selectedLanguage} = this.props;
		return (
			<Select clearable={false} searchable={false}
			        className="main-header__language-select"
			        value={selectedLanguage.id}
			        onChange={this.languageChangeHandler}
			        valueRenderer={this.flagRenderer}
			        optionRenderer={this.flagRenderer}
			        options={availableLanguages.map(lang => ({value: lang.id, label: lang.codeCountry}))}/>
		);
	}
}

export default LanguageForm;


// WEBPACK FOOTER //
// ./src/components/form/LanguageForm.js